import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {compose} from 'redux';

import {ErrorBoundary} from '../../components/error-boundary';
import RecentActivityHit from './recent-activity-hit.js';
import selectors from '../selectors';
import actions from '../actions';
import edap, {MORE_LOCATION} from '../edap';
import BackToScratchpadButton from './back-to-scratchpad-button';
import routes from '../../routes';
import Grid from '../../components/grid-layout';
import './recent-activity-details-container.less';
import BestMatch from './best-match';
import {getTranslations} from '../../selectors';
import {PAGE_RECENT_ACTIVITY_DETAILS} from '../../utils/edap';
import PageView from '../../components/PageView/PageView';
import {withPAR} from '../../components/Timing';
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {HA_PULSE_RECO_AB_TEST} from '../../abacus/experiments';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props';

// start [SCRATCHPAD-1344] ha_pulse_reco_ab_test
let isLogged = false;

export const logHaPulseRecoAbTestExposure = () => {
    if (isLogged) {
        return;
    }
    isLogged = true;
    AbacusClientUtils.evaluateExperimentAndLog(HA_PULSE_RECO_AB_TEST);
};
// end [SCRATCHPAD-1344] ha_pulse_reco_ab_test

export class RecentActivityDetailsContainer extends Component {
    static defaultProps = {
        markPAR: () => {},
        recoTestValue: 0
    }
    constructor(props) {
        super(props);
        this.seenHits = [];
    }

    componentDidMount() {
        const {fetchRecentActivity, recentActivityDetails} = this.props;
        if (!recentActivityDetails) {
            fetchRecentActivity();
        } else {
            edap.viewRecentActivityDetails(recentActivityDetails.searchTerm);
        }
        this.par(this.props);
    }

    componentWillReceiveProps = (nextProps) => {
        const {recentActivityDetails} = this.props;
        if (nextProps.recentActivityDetails
            && (
                !recentActivityDetails
                || recentActivityDetails.searchTerm !== nextProps.recentActivityDetails.searchTerm
            )
        ) {
            edap.viewRecentActivityDetails(nextProps.recentActivityDetails.searchTerm);
        }
        this.par(nextProps);
    }

    handleContinueSearchTopClick = () => {
        edap.seeMoreClick(MORE_LOCATION.TOP);
    }

    handleContinueSearchBottomClick = () => {
        edap.seeMoreClick(MORE_LOCATION.BOTTOM);
    }

    handleRemoveSearchClick = () => {
        const {removeRecentActivitySearch} = this.props;
        const {propertiesSummary, scratchpadId, searchTerm} = this.props.recentActivityDetails;

        const propertyIds = propertiesSummary && propertiesSummary.properties ?
            propertiesSummary.properties.map((property) => {
                return property.scratchpadId;
            }) : [];

        edap.removeSearchClick(searchTerm);
        removeRecentActivitySearch({scratchpadId, propertyIds});
    }

    handleDeletePropertyClick = (listingId, scratchpadId) => {
        const {recentActivityDetails} = this.props;
        const {searchTerm} = recentActivityDetails;
        const searchId = recentActivityDetails.scratchpadId;
        edap.removePropertyClick(searchTerm, listingId);
        this.props.removeRecentActivityProperty({scratchpadId, searchId});
    }

    handleBestMatchClick = (index) => {
        edap.bestMatchClick(index);
    }

    handleBestMatchNextArrowClick = () => {
        edap.bestMatchNextArrowClick();
    }

    handleBestMatchPreviousArrowClick = () => {
        edap.bestMatchPreviousArrowClick();
    }

    onWaypointEnter = (scratchpadId, index, hits) => {
        // avoid sending the event on scroll if we have already notified the back-end
        const alreadySeen = this.seenHits.indexOf(scratchpadId) !== -1;
        if (!alreadySeen) {
            this.seenHits.push(scratchpadId);
            edap.changeSeenEvent(index, hits.length, scratchpadId);
        }
    }

    par = (props = {}) => {
        const {recentActivityDetails} = props;
        // PAR definition: When recent activity details are fully loaded.
        if (recentActivityDetails) {
            this.props.markPAR();
        }
    }

    render() {
        const {
            backMessage,
            deleteMessage,
            errorTitle,
            errorMessage,
            seeMoreInMessage,
            seeMoreMessage,
            recentActivityDetails,
            locale,
            recoTestValue
        } = this.props;

        if (!recentActivityDetails) {
            return (<Redirect to={routes.TRIPBOARD} />);
        }

        // [SCRATCHPAD-1344] ha_pulse_reco_ab_test
        const useNewRecommendationService = recoTestValue > 0;

        const {
            arrivalDate,
            departureDate,
            endDate,
            guests,
            isDated,
            propertiesSummary,
            scratchpadId,
            searchTerm,
            searchTime,
            seeMoreLikeThis,
            startDate
        } = recentActivityDetails;

        const listingIds = propertiesSummary && propertiesSummary.properties ?
            propertiesSummary.properties.map((property) => {
                return property.hit.listingId;
            }) : [];

        return (
            <React.Fragment>
                <PageView pagename={PAGE_RECENT_ACTIVITY_DETAILS} />
                <div key="recent-activity-details-header" className="row remove-container-padding scratchpad-header">
                    <div className="col-md-10 col-md-offset-1 remove-col-padding">
                        <div className="main-header margin-bottom">
                            <BackToScratchpadButton buttonText={backMessage} />
                        </div>
                    </div>
                </div>
                <div key="recent-activity-details-body" className="row remove-container-padding">
                    <ErrorBoundary errorTitle={errorTitle} errorMessage={errorMessage}>
                        <div className="scratchpad-search-container col-md-10 col-md-offset-1 remove-col-padding">
                            {searchTime && (
                                <div className="scratchpad-search-time text-left text-muted">
                                    {searchTime}
                                </div>
                            )}
                            <div className="col-xs-12 scratchpad-search-text hidden-xs">
                                <div className="scratchpad-search-header">
                                    <svg className="inline-svg scratchpad-search-icon">
                                        <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#svg-magnifying-glass" />
                                    </svg>
                                    <h2 className="scratchpad-search-term">{searchTerm}</h2>
                                    {arrivalDate && (
                                        <span className="scratchpad-dates-container">{arrivalDate} {departureDate && (`${String.fromCharCode(0x2192)} ${departureDate}`)}</span>
                                    )}
                                    {guests && (
                                        /* eslint-disable react/jsx-no-literals */
                                        <span className="scratchpad-guests-container hidden-xs">{arrivalDate && (<span className="hidden-xs">&nbsp; &#8226; &nbsp;</span>)}{guests}</span>
                                    )}
                                </div>
                                <div>
                                    <a href={seeMoreLikeThis.href} onClick={this.handleContinueSearchTopClick} className="btn btn-primary btn-icon-circle visible-xs-block" data-effect="ripple" title={seeMoreMessage}>
                                        <i className="icon-search" />
                                    </a>
                                    <a href={seeMoreLikeThis.href} onClick={this.handleContinueSearchTopClick} className="btn btn-primary scratchpad-button btn-sm hidden-xs scratchpad-btn-see-more" data-effect="ripple">
                                        {seeMoreMessage}
                                    </a>
                                    <svg onClick={this.handleRemoveSearchClick} className="inline-svg scratchpad-btn-remove-search hidden-xs" aria-label={deleteMessage}>
                                        <title>{deleteMessage}</title>
                                        <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#svg-remove" />
                                    </svg>
                                </div>
                            </div>

                            <span className="visible-xs-block">
                                <div
                                    className="col-xs-12 scratchpad-search-text"
                                    onClick={this.handleContinueSearchTopClick}
                                    onKeyPress={this.handleContinueSearchTopClick}
                                    role="button"
                                    tabIndex="0"
                                >
                                    <a className="scratchpad-search-header-xs" href={seeMoreLikeThis.href}>
                                        <svg className="inline-svg scratchpad-search-icon">
                                            <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#svg-magnifying-glass" />
                                        </svg>
                                        <h4 className="scratchpad-search-heading-xs">{searchTerm}</h4>
                                        {arrivalDate && (
                                            <div className="scratchpad-dates-container">{arrivalDate} {departureDate && (`${String.fromCharCode(0x2192)} ${departureDate}`)}</div>
                                        )}
                                        {guests && (
                                            <div className="scratchpad-guests-container">{guests}</div>
                                        )}
                                    </a>
                                    <svg className="inline-svg scratchpad-btn-remove-search pull-right" onClick={this.handleRemoveSearchClick}>
                                        <use xmlnsXlink="http://www.w3.org/2000/xlink" xlinkHref="#svg-remove" />
                                    </svg>
                                </div>
                            </span>
                            {propertiesSummary && (
                                <div className="scratchpad-search-hits-wrapper col-xs-12">
                                    <div className="scratchpad-search-hits">
                                        {propertiesSummary.headerSummary.text && (
                                            <div className="text-muted scratchpad-search-number">
                                                {propertiesSummary.headerSummary.text}
                                            </div>
                                        )}
                                        {propertiesSummary.properties && (
                                            <div className="scratchpad-hit-container">
                                                <Grid>
                                                    {propertiesSummary.properties.map((property, index, hits) => (
                                                        <RecentActivityHit
                                                            {...property}
                                                            {...this.props}
                                                            key={index}
                                                            hits={hits}
                                                            index={index}
                                                            isDated={isDated}
                                                            seenHits={this.seenHits}
                                                            handleDeletePropertyClick={this.handleDeletePropertyClick}
                                                            onWaypointEnter={this.onWaypointEnter}
                                                        />
                                                    ))}
                                                </Grid>
                                            </div>
                                        )}
                                        {propertiesSummary.footerSummary && (
                                            <div className="scratchpad-search-related text-center">
                                                <a href={seeMoreLikeThis.href}
                                                    onClick={this.handleContinueSearchBottomClick}
                                                    className="btn btn-primary continue-search-button scratchpad-button hidden-xs"
                                                    data-bypass="true"
                                                    data-effect="ripple"
                                                >
                                                    {seeMoreInMessage && seeMoreInMessage.replace('{0}', searchTerm)}
                                                </a>
                                                <a href={seeMoreLikeThis.href} onClick={this.handleContinueSearchBottomClick} className="btn btn-primary continue-search-button scratchpad-button visible-xs-block" data-bypass="true" data-effect="ripple">
                                                    {seeMoreMessage}
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                    <div className="scratchpad-hit-gallery">
                                        <BestMatch
                                            arrowBackgroundColor={{
                                                red: 247,
                                                green: 247,
                                                blue: 248
                                            }}
                                            listingIds={listingIds}
                                            onNextClick={this.handleBestMatchNextArrowClick}
                                            onPreviousClick={this.handleBestMatchPreviousArrowClick}
                                            scratchpadId={scratchpadId}
                                            searchTerm={searchTerm}
                                            onClick={this.handleBestMatchClick}
                                            startDate={startDate}
                                            endDate={endDate}
                                            useNewRecommendationService={useNewRecommendationService}
                                            logHaPulseRecoAbTestExposure={logHaPulseRecoAbTestExposure}
                                            locale={locale}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </ErrorBoundary>
                </div>
            </React.Fragment>
        );
    }
}

RecentActivityDetailsContainer.propTypes = {
    backMessage: PropTypes.string,
    deleteMessage: PropTypes.string,
    recentActivityDetails: PropTypes.shape({
        arrivalDate: PropTypes.string,
        departureDate: PropTypes.string,
        endDate: PropTypes.string,
        guests: PropTypes.string,
        propertiesSummary: PropTypes.shape({
            headerSummary: PropTypes.shape({text: PropTypes.string}),
            properties: PropTypes.arrayOf(PropTypes.shape({}))
        }),
        scratchpadId: PropTypes.string,
        searchTerm: PropTypes.string,
        searchTime: PropTypes.string,
        seeMoreLikeThis: PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.string
        }),
        startDate: PropTypes.string
    }),
    seeMoreInMessage: PropTypes.string,
    seeMoreMessage: PropTypes.string,
    useNewRecommendationService: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    const linkId = ownProps.match.params.linkId;
    const recentActivityDetails = selectors.getRecentActivityDetails(state, linkId);
    const translations = getTranslations(state);
    return {
        backMessage: translations['scratchpad.button.back'],
        deleteMessage: translations['scratchpad.button.delete'],
        errorTitle: translations['th.inbox.error.title'],
        errorMessage: translations['th.inbox.error.message'],
        pagename: PAGE_RECENT_ACTIVITY_DETAILS,
        recentActivityDetails,
        locale: state.system.fullLocale,
        seeMoreInMessage: translations['scratchpadFullSummary.searchesSummary.propertiesSummary.footer.seeMoreIn'],
        seeMoreMessage: translations['scratchpadFullSummary.searchesSummary.seeMore']
    };
}

const mapDispatchToProps = {
    fetchRecentActivity: actions.fetchRecentActivity,
    removeRecentActivitySearch: actions.removeRecentActivitySearch,
    removeRecentActivityProperty: actions.removeRecentActivityProperty
};


export default compose(
    withPAR,
    connect(mapStateToProps, mapDispatchToProps),
    withAbacusTestValuesAsProps({
        [HA_PULSE_RECO_AB_TEST]: 'recoTestValue'
    })
)(RecentActivityDetailsContainer);



// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/recent-activity-details-container.js